"use client";

import { useRouter } from "next/navigation";
import Image from "next/image";
import { useDict } from "@/components/providers/LocaleProvider";

export default function SeeAllProjectsCard() {
  const router = useRouter();
  const t = useDict();

  const go = () => router.push("/projects");

  return (
    <div
      role="button"
      tabIndex={0}
      aria-label={t.home.projects.seeAllProjects}
      onClick={go}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          go();
        }
      }}
      className="
        group relative w-full lg:w-[12%]
        min-h-[160px] lg:min-h-[320px]   /* ensure visible on mobile & tabs */
        rounded-2xl overflow-hidden cursor-pointer
        transition-all duration-700
      "
    >
      {/* Background image (fills container) */}
      <Image
        src="/assets/see-all-projects.avif"
        alt="See all projects Image"
        fill
        className="object-cover"
        priority={false}
        sizes="(max-width: 768px) 100vw, 12vw"
      />

      {/* Overlay */}
      <div className="absolute inset-0 bg-background/80 z-10 rounded-2xl flex items-center justify-center transition-colors duration-500 group-hover:bg-background/60">
        <p className="font-semibold text-white text-center lg:-rotate-90">
          {t.home.projects.seeAllProjects}
        </p>
      </div>
    </div>
  );
}
